import React from "react";

// D-09 / UI-SPEC S8 — public verified-owner pill.
// Green success semantic (deliberately distinct from the orange brand accent so it reads
// as a trust signal, not a CTA). Shown ONLY when the store has an approved StoreClaim,
// signalled by `store.hasVerifiedOwner` on the public store response. Renders nothing
// when `show` is false.
export default function StoreVerifiedBadge({ show }: { show?: boolean }) {
  if (!show) return null;

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        fontFamily: "var(--ys-font)",
        fontSize: 12,
        fontWeight: 600,
        color: "var(--ys-success)",
        background: "var(--ys-success-soft)",
        borderRadius: "var(--ys-r-pill)",
        padding: "3px 10px",
        whiteSpace: "nowrap",
      }}
    >
      <svg
        width="13"
        height="13"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ flexShrink: 0 }}
        aria-hidden="true"
      >
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        <path d="M9 12l2 2 4-4" />
      </svg>
      تم التحقق من المالك
    </span>
  );
}
